import { Component } from '@angular/core';
import { Alert, AlertService } from '../service/alert.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css'
})
export class AlertComponent {

  constructor(public alertService: AlertService) { }

  close() {
    this.alertService.closeAlert();
  }
}
